// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AzzT_","tabsBox":"styles_tabsBox__2vGHD","createButton":"styles_createButton__3hsJF"};